import toast from "react-hot-toast";
import { login,  refresh, updateCategoires, addCategoires, deleteCategoires, addInputs, updateInputs, deleteInputs, addPackages, updatePackages, deletePackages, deleteUsers, updateUsersStatus, updateConfirmUsers, updateConfirmOrders, deleteAds, updateCategoriesBlog, deleteCategoiresBlogs, addCategoriesBlog, addBlogs, updateBlogs, deleteBlogs, updateReadNotification, updateReadAllNotifications, updatePaymentMethod, updatePermissions, updateRoles, delelteRoles, addRoles, addNotifications, addEmployees, delelteEmployees, updateEmployees, updateReportStatus, addPages, deleltePages, updatePages, addPagesSection, deleltePagesSection, updatePagesSection, addPrices, updatePrices, deletePrices, addStores, updateStores, deleteStores, addDeliveryBoys, updateDeliveryBoys, deleteDeliveryBoys, deleteProducts, updateProducts, addProducts, updateOrders, updateSettings, addCopons, updateCopons, deleteCopons, logout, addTransactions } from "./apiCalls";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

export async function LoginForm(formdata) {

    try {
        const response = await login(formdata);

        if (response.status === 200) {
            // toast.success("تم تسجيل الدخول بنجاح");
            
            toast("تم تسجيل الدخول بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            localStorage.setItem("token", response.data.data.token);
            const permissions = response.data.data.user.permissions.map((e) => e.name);
            localStorage.setItem("permissions", JSON.stringify(permissions));
            localStorage.setItem("userData", JSON.stringify({
                userName: response.data.data.user.name,
                userId: response.data.data.user.id,
                email: response.data.data.user.email,
                role_name: response.data.data.user.role
            }));
            // if (response.data.data.permissions.filter((e) => e.guard_name == "dashboard.access")) {
            //     navigate("/");
            // }
            // else {
            //     navigate("/brands");
            // }
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error(error, { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function LogoutForm(formdata) {

    try {
        const response = await logout(formdata);

        if (response.status === 200) {
            
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error(error, { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function RefreshToken(formdata) {

    try {
        const response = await refresh(formdata);
        if (response.status === 200) {
            localStorage.setItem("token", response.data.data.token);
            return response;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    };
};

////////////////////////////Prices////////////////////////////////////

export async function addPricesForm(formdata, navigate) {

    try {
        const response = await addPrices(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة السعر بنجاح");
            navigate("/prices", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updatePricesForm(id, formdata, navigate) {

    try {
        const response = await updatePrices(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل السعر بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/prices");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateSettingsForm(formdata) {

    try {
        const response = await updateSettings(formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الاعدادات بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deletePricesForm(id) {

    try {
        const response = await deletePrices(id);

        if (response.status == 200) {
            toast.success("تم حذف السعر بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Stores////////////////////////////////////

export async function addStoresForm(formdata, navigate) {

    try {
        const response = await addStores(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة المتجر بنجاح");
            navigate("/stores", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateStoresForm(id, formdata, navigate) {

    try {
        const response = await updateStores(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل المتجر بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/categories");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteStoresForm(id) {

    try {
        const response = await deleteStores(id);

        if (response.status == 200) {
            toast.success("تم حذف المتجر بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Copons////////////////////////////////////

export async function addCoponsForm(formdata, navigate) {

    try {
        const response = await addCopons(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة الكوبون بنجاح");
            navigate("/stores", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateCoponsForm(id, formdata, navigate) {

    try {
        const response = await updateCopons(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الكوبون بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/categories");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteCoponsForm(id) {

    try {
        const response = await deleteCopons(id);

        if (response.status == 200) {
            toast.success("تم حذف الكوبون بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////deliveryBoys////////////////////////////////////

export async function addDeliveryBoysForm(formdata, navigate) {

    try {
        const response = await addDeliveryBoys(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة موظف التوصيل بنجاح");
            navigate("/deliveryBoys", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function addTransactionsForm(formdata, navigate) {

    try {
        const response = await addTransactions(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة موظف التوصيل بنجاح");
            navigate("/deliveryBoys", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateDeliveryBoysForm(id, formdata, navigate) {

    try {
        const response = await updateDeliveryBoys(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل موظف التوصيل بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/deliveryBoys");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteDeliveryBoysForm(id) {

    try {
        const response = await deleteDeliveryBoys(id);

        if (response.status == 200) {
            toast.success("تم حذف موظف التوصيل بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Products ////////////////////////////////////

export async function addProductsForm(formdata, navigate) {

    try {
        const response = await addProducts(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة المنتج بنجاح");
            navigate("/products", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateProductsForm(id, formdata, navigate) {

    try {
        const response = await updateProducts(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل المنتج بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/products");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteProductsForm(id) {

    try {
        const response = await deleteProducts(id);

        if (response.status == 200) {
            toast.success("تم حذف المنتج بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Orders////////////////////////////////////

export async function updateOrdersForm(id, formdata, navigate) {

    try {
        const response = await updateOrders(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل موظف التوصيل بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/products");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Categories////////////////////////////////////

export async function addCategoiresForm(formdata, navigate) {

    try {
        const response = await addCategoires(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة الصنف بنجاح");
            navigate("/categories", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateCategoriesForm(id, formdata, navigate) {

    try {
        const response = await updateCategoires(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الصنف بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/categories");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteCategoriesForm(id) {

    try {
        const response = await deleteCategoires(id);

        if (response.status == 200) {
            toast.success("تم حذف الفئة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Inputs////////////////////////////////////

export async function addInputsForm(formdata, navigate) {

    try {
        const response = await addInputs(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة الحقل بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/inputs");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateInputsForm(id, formdata, navigate) {

    try {
        const response = await updateInputs(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الحقل بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/inputs");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteInputsForm(id) {

    try {
        const response = await deleteInputs(id);

        if (response.status == 200) {
            toast.success("تم حذف الحقل بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////packages////////////////////////////////////

export async function addPackagesForm(formdata, navigate) {

    try {
        const response = await addPackages(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة الباقة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/packages");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updatePackagesForm(id, formdata, navigate) {

    try {
        const response = await updatePackages(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الباقة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/packages");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deletePackagesForm(id) {

    try {
        const response = await deletePackages(id);

        if (response.status == 200) {
            toast.success("تم حذف الباقة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Users////////////////////////////////////

export async function updateUsersStatusForm(id, formdata) {

    try {
        const response = await updateUsersStatus(id, formdata);
        if (response.status == 200) {
            console.log(response)
            toast.success("تم تعديل الحالة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateConfirmUsersForm(id, formdata, ) {

    try {
        const response = await updateConfirmUsers(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الحالة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteUsersForm(id) {

    try {
        const response = await deleteUsers(id);

        if (response.status == 200) {
            toast.success("تم حذف المستخدم بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Users////////////////////////////////////

export async function updateConfirmOrdersForm(id, formdata) {

    try {
        const response = await updateConfirmOrders(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الحالة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Ads////////////////////////////////////

export async function deleteAdsForm(id) {

    try {
        const response = await deleteAds(id);

        if (response.status == 200) {
            toast.success("تم حذف الاعلان بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Categories of Blogs////////////////////

export async function addCategoriesBlogForm(formdata, navigate) {

    try {
        const response = await addCategoriesBlog(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة الفئة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/categoriesBlog");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateCategoriesBlogForm(id, formdata, navigate) {

    try {
        const response = await updateCategoriesBlog(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الفئة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/categoriesBlog");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteCategoriesBlogForm(id) {

    try {
        const response = await deleteCategoiresBlogs(id);

        if (response.status == 200) {
            toast.success("تم حذف الفئة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

////////////////////////////Blogs//////////////////////////////////

export async function addBlogsForm(formdata, navigate) {

    try {
        const response = await addBlogs(formdata);

        if (response.status == 201) {
            toast.success("تم إضافة المقالة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/blogs");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateBlogsForm(id, formdata, navigate) {

    try {
        const response = await updateBlogs(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل المقالة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/blogs");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteBlogForm(id) {

    try {
        const response = await deleteBlogs(id);

        if (response.status == 200) {
            toast.success("تم حذف المقالة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};


///////////////////////////Notifications///////////////////////////

export async function updateReadAllNotificationForm(id, formdata) {

    try {
        const response = await updateReadAllNotifications(id, formdata);

        if (response.status == 200) {
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateReadNotificationForm(id, formdata) {

    try {
        const response = await updateReadNotification(id, formdata);

        if (response.status == 200) {
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

///////////////////////////////Payment Method////////////////////////

export async function updatePaymentMethodForm(id, formdata) {

    try {
        const response = await updatePaymentMethod(id, formdata);

        if (response.status == 200) {
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function addNotificationsForm(formdata, navigate) {

    try {
        const response = await addNotifications(formdata);

        if (response.status === 201) {
            toast.success("تم ارسال الاشعار بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            if(navigate){
                navigate("/notifications/outgoing");
            }
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

///////////////////////////////Roles////////////////////////////////

export async function addRolesForm(formdata, navigate) {

    try {
        const response = await addRoles(formdata);

        if (response.status === 201) {
            toast.success("تم إضافة المتجر بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/roles");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function deleteRolesForm(id) {

    try {
        const response = await delelteRoles(id);

        if (response.status == 200) {
            toast.success("تم حذف الدور بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateRolesForm(id, formdata, navigate) {

    try {
        const response = await updateRoles(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الدور بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/roles");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updatePermissionForm(id, formdata, navigate) {

    try {
        const response = await updatePermissions(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الصلاحيات بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/roles");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};


//////////////////////////////////////Employees Cruds//////////////////////////

export async function addEmployeesForm(formdata, navigate) {

    try {
        const response = await addEmployees(formdata);

        if (response.status === 201) {
            toast.success("تم إضافة الموظف بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/roles");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function deleteEmployeesForm(id) {

    try {
        const response = await delelteEmployees(id);

        if (response.status == 200) {
            toast.success("تم حذف الموظف بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updateEmployeesForm(id, formdata, navigate) {

    try {
        const response = await updateEmployees(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الموظف بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/roles");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

//////////////////////////////////////////////Report Cruds///////////////////////////////////////////

export async function updateReportsForm(id) {

    try {
        const response = await updateReportStatus(id);

        if (response.status == 200) {
            toast.success("تم تعديل حالة الابلاغ بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

///////////////////////////////////////////Pages Cruds/////////////////////////////////////

export async function addPagesForm(formdata, navigate) {

    try {
        const response = await addPages(formdata);

        if (response.status === 201) {
            toast.success("تم إضافة الصفحة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/pages");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function deletePagesForm(id) {

    try {
        const response = await deleltePages(id);

        if (response.status == 200) {
            toast.success("تم حذف الصفحة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updatePagesForm(id, formdata, navigate) {

    try {
        const response = await updatePages(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل الصفحة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/pages");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

///////////////////////////////////////////Pages Cruds/////////////////////////////////////

export async function addPagesSectionForm(formdata, navigate) {

    try {
        const response = await addPagesSection(formdata);

        if (response.status === 201) {
            toast.success("تم إضافة قسم للصفحة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/pages");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الإضافة . يرجى المحاولة مرة أخرى");
        return null;
    };
};

export async function deletePagesSectionForm(id) {

    try {
        const response = await deleltePagesSection(id);

        if (response.status == 200) {
            toast.success("تم حذف قسم الصفحة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة الحذف . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};

export async function updatePagesSectionForm(id, formdata, navigate) {

    try {
        const response = await updatePagesSection(id, formdata);

        if (response.status == 200) {
            toast.success("تم تعديل قسم الصفحة بنجاح", { icon: <CheckCircleIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            navigate("/pages");
            return response;
        } else {
            toast.error(response.response.data.errors.map((e) => e), { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
            return null;
        }
    } catch (error) {
        toast.error("حدث خطأ أثناء محاولة التعديل . يرجى المحاولة مرة أخرى", { icon: <ErrorIcon/>, style: { borderRadius: '10px', background: '#333', color: '#fff'},});
        return null;
    };
};